import { Tr, Td, Th } from '@patternfly/react-table'
import * as React from 'react'
import { useMemo } from 'react'

interface InstrumentListRowProps {
  content: string
  numberOfEntries: number
}

export const EmptyResponseHistoryRow = ({
  content,
  numberOfEntries,
}: InstrumentListRowProps) => {
  const emptyRow = useMemo(() => {
    const tds = []
    for (let i = 0; i < numberOfEntries; i++) {
      tds[i] = <Td key={`empty-td-${i}`} width={10} />
    }
    return tds
  }, [numberOfEntries])

  return (
    <Tr>
      <Th isStickyColumn modifier="wrap" width={20}>
        {content}
      </Th>
      {emptyRow}
    </Tr>
  )
}
